import api from "../api";

export const deleteFailedTransactions = async (transactionId: string | number) => {
  
  const response = await api.delete(
    `/20card/api/pazirande/delete-failed-transactions`,
    {
      data: { transaction_id: transactionId }
    }
  );
  return response.data;
};
